import Box from "@mui/material/Box";
import { styled } from "@mui/material";

const ArchivedBadgeContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
}));

type ArchivedBadgeProps = {
  title?: string;
  category: string;
};

export default function ArchivedBadge(props: Readonly<ArchivedBadgeProps>) {
  const { title, category } = props;

  return (
    <ArchivedBadgeContainer>
      <span>{title ?? category}</span>
    </ArchivedBadgeContainer>
  );
}
